"use client";

import { ChevronRight, XCircle } from "lucide-react";
import Link from "next/link";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { SectionDescription } from "@/components/ui/sectionDescription";
import { SectionTitle } from "@/components/ui/sectionTitle";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);

    fetch("/log-error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: error.message,
        stack: error.stack,
        digest: error.digest,
      }),
    }).catch(() => {});
  }, [error]);

  return (
    <div className='mx-auto flex w-full max-w-[629px] flex-col items-center gap-[30px] py-[80px] text-center sm:min-h-[600px]'>
      <XCircle className='size-21 animate-[fadeIn_1s_ease-in-out] text-destructive transition-colors' />

      <SectionTitle
        variant='blue'
        className='text-center text-[28px] lg:text-[40px]'
      >
        Algo deu errado!
      </SectionTitle>

      <SectionDescription>
        Se o problema persistir conte o administrador.
      </SectionDescription>

      <div className='flex flex-col gap-5 sm:flex-row'>
        <Button onClick={() => reset()}>Tentar novamente</Button>

        <Button
          variant='outline'
          className='!pl-[30px] !pr-5 h-14 w-fit rounded-full border-primary-blue bg-transparent py-2.5 text-[22px] text-primary-blue hover:bg-[#f0f3fb] hover:text-primary-blue'
          asChild
        >
          <Link href='/contato'>
            Fale conosco
            <ChevronRight className='size-[25px]' />
          </Link>
        </Button>
      </div>
    </div>
  );
}
